<template>
  <div class="storage-management">
    <div class="search">
      <el-form ref="searchForm" :model="searchForm" label-width="100px">
        <el-form-item label="仓库：" prop="warehouseId" class="customer-form">
          <el-select 
            class="white"
            clearable
            v-model="searchForm.warehouseId"
            placeholder="请选择仓库"
          >
            <el-option
              v-for="item in warehouseList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="日期：" prop="date">
          <el-date-picker
            v-model="searchForm.date"
            type="date"
            value-format="yyyy-MM-dd"
            placeholder="选择日期"
          ></el-date-picker>
        </el-form-item>
        <el-button class="btn-blue" @click="search">搜索</el-button>
        <el-button class="btn-white" @click="resetForm('searchForm')">清空</el-button>
      </el-form>
      <div class="operation-btn">
        <el-button
          class="btn-white download-content"
          icon="el-icon-download"
          @click="openEntry"
          >录入</el-button
        >
      </div>
    </div>
    <div class="table">
      <el-table ref="table" :data="tableData" style="width: 100%">
        <el-table-column
          v-for="(item, index) in tableTitleList"
          :key="index"
          :prop="item.prop"
          :label="item.label"
          show-overflow-tooltip
          :min-width="item.width"
        ></el-table-column>
      </el-table>
      <div class="pagination">
        <pagination-tpl
          :total="total"
          :currentPage="currentPage"
          :pageSize="pageSize"
          @queryChange="queryChange"
        ></pagination-tpl>
      </div>
    </div>

    
    <el-dialog
      title="录入"
      top="12vh"
      :visible.sync="dialog"
      width="600px"
      :close-on-click-modal="false"
      :before-close="closeDialog"
      class="entry-dialog"
    >
      <el-form class="entry-form" ref="entryForm" :model="entryForm" :rules="rules">
        <el-form-item label="仓库" prop="warehouseId">
          <el-select 
            class="white"
            clearable
            v-model="entryForm.warehouseId"
            placeholder="请选择仓库"
          >
            <el-option
              v-for="item in warehouseList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="日期" prop="date">
          <el-date-picker
            v-model="entryForm.date"
            type="date"
            value-format="yyyy-MM-dd"
            placeholder="选择日期"
            clearable
          ></el-date-picker>
        </el-form-item>
        <div class="title">
          导入信息
        </div>
        
        <div class="labor-info">
          <div>
            <div>
              <i class="el-icon-warning"></i>
              <span class="sub-title introduce">功能介绍</span>
            </div>
            <p class="tips">根据各项目实际占仓情况导入相应数据</p>
          </div>
          <div class="down-tmp">
            <div class="sub-title">
              <span>下载导入模板</span>
              <span class="sub-tips">(点击下载)</span>
            </div>
            <el-button type="text" class="btn-text" @click="downTmp">储位导入模板.xlsx</el-button>
          </div>
          <div>
            <p class="sub-title">储位信息导入</p>
            <el-upload
              v-if="isUpload"
              v-loading.fullscreen.lock="loading3"
              element-loading-text="文件上传中"
              element-loading-spinner="el-icon-loading"
              element-loading-background="rgba(0, 0, 0, 0.8)"
              class="upload"
              ref="upload"
              action="#"
              :show-file-list="false"
              :auto-upload="true"
              :before-upload="uploadExcel"
            >
              <el-button slot="trigger" type="text" class="btn-text"
                >{{uploadTipsName}}</el-button
              >
            </el-upload>
            <div v-else class="upload-tips-container">
              <div class="upload-tips-name">
                {{uploadTipsName}}
                <i class="el-icon-error" @click="removeUploadOrder"></i>
              </div>
            </div>
          </div>
        </div>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button class="btn-white" @click="closeDialog">取消</el-button>
        <el-button class="btn-blue" @click="confirm('entryForm')">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import PaginationTpl from "components/base/PaginationTpl";
import Expenses from "models/expenses";
const expenses = new Expenses();
import StorageManageMent from "models/data-entry/storage-management";
export default {
  components: {
    PaginationTpl
  },

  data() {
    return {
      total: 0,
      currentPage: 1,
      pageSize: 20,
      tableData: [],
      tableTitleList: [
        {label: '日期', prop: 'createTime', width: '150'},
        {label: '仓库', prop: 'warehouseName', width: ''},
        {label: '客户简称', prop: 'customerName', width: ''},
        {label: '库区名称', prop: 'warehouseAreaName', width: ''},
        {label: '库位数量', prop: 'quantity', width: ''},
      ],
      warehouseList: [],
      searchForm: {
        warehouseId: '',
        date: ''
      },
      
      dialog: false,
      entryForm: {
        warehouseId: '',
        date: ''
      },
      rules: {
        warehouseId: [
          { required: true, message: '请选择仓库', trigger: 'change' }
        ],
        date: [
          { required: true, message: '请选择日期', trigger: 'change' }
        ]
      },
      loading3: false,
      uploadTipsName: '点击导入',
      /* 订单导入的流 */
      formData: null,
      /* 是否导入 */
      isUpload: true,
    }
  },

  created() {
    this.initList()
    this.getWarehouseList()
  },

  methods: {
    //获取仓库数据
    getWarehouseList() {
      expenses.getWarehouseData().then(res => {
        if (res.success) {
          let arr = [];
          res.result.map(value => {
            let obj = {};
            obj.id = value.id;
            obj.name = value.name;
            arr.push(obj);
          });
          this.warehouseList = arr;
        }
      });
    },
    
    initList() {
      let currentPage = this.currentPage
      let warehouseId = this.searchForm.warehouseId
      let customerId = this.searchForm.customerId
      let projectId = this.searchForm.projectId
      let reportDate = this.searchForm.date
      let data = {
        currentPage,
        warehouseId,
        customerId,
        projectId,
        reportDate
      }
      StorageManageMent.getStorageManageMentList(data).then(res => {
        if (res.success) {
          let arr = []
          this.total = res.result.totalNum
          this.pageSize = res.result.pageSize
          res.result.items.map(i => {
            let obj = {}
            obj.id = i.id
            obj.createTime = i.reportDate
            obj.warehouseName = i.warehouseName
            obj.warehouseAreaName = i.warehouseAreaName
            obj.customerName = i.customerName
            obj.quantity = i.num
            arr.push(obj)
          })
          this.tableData = arr
        } else {
          this.$message.error(res.message)
        }
      })
    },
    
    /* 获取储位导入模板 */
    initStorageTmp() {
      let warehouseId = this.entryForm.warehouseId
      StorageManageMent.getStorageTmp(warehouseId).then(res => {
        let blob = new Blob([res.data], { type: res.headers.contentType });
        let fileName = window.decodeURI(
          res.headers["content-disposition"].split("=")[1]
        );
        var url = URL.createObjectURL(blob);
        var a = document.createElement("a");
        a.href = url;
        a.download = fileName;
        a.click();
        // 释放之前创建的URL对象
        window.URL.revokeObjectURL(url);
      })
    },

    queryChange(data) {
      this.currentPage = data.currentPage;
      this.initList();
    },

    search() {
      this.currentPage = 1
      this.initList();
    },

    resetForm(formName) {
      this.$refs[formName].resetFields();
    },

    openEntry() {
      this.dialog = true
    },

    closeDialog() {
      this.entryForm.warehouseId = ''
      this.entryForm.date = ''
      this.removeUploadOrder()
      this.dialog = false
    },

    confirm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let warehouseId = this.entryForm.warehouseId
          let reportDate = this.entryForm.date
          
          if (this.isUpload) {
            return this.$message.error("请导入文件");
          }
          let formData = this.formData
          if (formData.get('warehouseId')) {
            formData.delete('warehouseId')
          }
          if (formData.get('reportDate')) {
            formData.delete('reportDate')
          }
          formData.append("warehouseId", warehouseId);
          formData.append("reportDate", reportDate);
          StorageManageMent
            .postExcel(formData)
            .then(res => {
              if (res.success) {
                this.$message.success("导入成功");
                this.initList()
                this.closeDialog()
              } else {
                this.$confirm(res.message, "提示", {
                  showCancelButton: false,
                  confirmButtonText: "确定",
                  type: "warning"
                }).then(() => {});
              }
            })
            .catch(res => {
              console.log(res);
              this.$message.error("导入失败");
            });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },

    downTmp() {
      if (!this.entryForm.warehouseId) return this.$message.error('请选择仓库')
      this.initStorageTmp()
    },
    removeUploadOrder() {
      this.formData = null
      this.uploadTipsName = '点击导入'
      this.isUpload = true
    },
    //导入Excel表格
    uploadExcel(file) {
      let formData = new FormData();
      formData.append("file", file);
      this.formData = formData
      this.uploadTipsName = file.name
      this.isUpload = false
      return false;
    },
  }
}
</script>

<style lang='scss'>
.storage-management {
  flex: 1;
  background: #fff;
  border-radius: 4px;
  box-sizing: border-box;
  .search {
    background: #fff;
    border-radius: 8px;
    margin-bottom: 16px;
    padding: 0px 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid #eee;
    .btn-blue,
    .btn-gray {
      margin-left: 16px;
    }
    .download-content {
      padding: 0px 14px;
    }
    .el-form {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      height: 72px;
      .el-form-item {
        margin-bottom: 0px;
      }
      .customer-form {
        .el-form-item__label {
          width: 50px!important;
        }
        .el-form-item__content {
          margin-left: 50px!important;
        }
      }
    }
  }
  .table {
    padding: 16px;
  }
  .pagination {
    display: flex;
    justify-content: flex-end;
  }

  
  .entry-dialog {
    .el-dialog__header {
      border-bottom: 1px solid #eee;
      margin-bottom: 16px;
    }
    .entry-form {
      .el-form-item {
        .el-form-item__label {
          width: 100%;
          text-align: left;
        }
        .el-form-item__content,
        .el-select,
        .el-date-editor {
          width: 100%;
        }
      }
      
      .title {
        margin-bottom: 10px;
        font-size: 14px;
        font-weight: 400;
        color: #666666;
      }
      .labor-info {
        padding: 20px;
        border: 1px solid #eee;
        .processing-progress {
          margin-top: 16px;
        }


        .down-tmp {
          margin-bottom: 8px;
        }
        .el-icon-warning {
          font-size: 16px;
          color: #F47A25;
          margin-right: 6px;
          vertical-align: middle;
          margin-bottom: 2px;
        }
        .sub-title {
          font-size: 14px;
          font-weight: 400;
          color: #333333;
        }
        .introduce {
          display: inline-block;
        }
        .tips {
          font-size: 14px;
          font-weight: 400;
          color: #999999;
          margin: 11px 0px 21px 0px;
        }
        .upload-tips-container {
          position: relative;
          width: 180px;
          .upload-tips-name {
            height: 30px;
            line-height: 30px;
            margin: 12px 0px;
            color: #2E68EA;
            background: #EBEEF5;
            border-radius: 2px;
            padding-left: 7px;
            box-sizing: border-box;
            overflow : hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 1;
            -webkit-box-orient: vertical;
            .el-icon-error {
              position: absolute;
              top: -5px;
              right: -8px;
              color: #999999;
              cursor: pointer;
            }
          }
        }
        .sub-tips {
          color: #999999;
        }
      }
    }
    .el-dialog__footer {
      padding: 0px;
      .dialog-footer {
        border-top: 1px solid #eee;
        padding-top: 16px;
        padding-bottom: 16px;
        display: flex;
        justify-content: center;
      }
    }
  }
}
</style>
